import React, { useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

import "./productslider.css";

import silent_Action from "../../../redux/silent_auction/actions";
import { useDispatch, useSelector } from "react-redux";

// import required modules
import { FreeMode, Navigation, Thumbs } from "swiper";

const ProductSlider = ({Img, itemId, isWatchlistItem}) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [isFavourite, setIsFavourite] = useState(isWatchlistItem);

  const dispatch = useDispatch();
  const Auth = useSelector((state) => state.Auth);
  
  const AddWatchlist = (itemId) => {
    var response = dispatch(silent_Action.addWatchlist({
      itemId: itemId,
      token: Auth.auth.access_token,
      afterAction: () => {
        setIsFavourite(true);
      }
    }));
  }

  const RemoveFromWatchlist = (itemId) => {
    var response = dispatch(silent_Action.removeFromWatchlist({
      itemId: itemId,
      token: Auth.auth.access_token,
      afterAction: () => {
        setIsFavourite(false);
      }
    }));
  }


  return (
    <>
    {Img?.length>0 ?
      <div>
        
      <Swiper
        style={{
          "--swiper-navigation-color": "#fff",
          "--swiper-pagination-color": "#fff"
        }}
        spaceBetween={10}
        navigation={true}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper2"
      >
       {Img?.length>0?
       Img.map((item,k)=>(
        <SwiperSlide key={k}>
        <img src={item.Url} alt="slider" />     
        {!isFavourite &&                   
         <button onClick={() => AddWatchlist(itemId)} className="button-primary button watchlistButton watchlistIconPosition">
            <i className="far fa-heart fa-heart-style"></i>
          </button>  
        }  
        {isFavourite &&                   
          <button onClick={() => RemoveFromWatchlist(itemId)} className="button-primary button watchlistButton watchlistButtonAfter watchlistIconPosition">
            <i className="far fa-heart fa-heart-style"></i>
          </button>   
        }  
      </SwiperSlide>)
       )
       :(<SwiperSlide>
          <img src="/assets/images/Item_ComingSoon.jpg" alt="slider" />
        </SwiperSlide>)
       }
      
       
      </Swiper>
      <Swiper
        onSwiper={setThumbsSwiper}
        spaceBetween={10}
        slidesPerView={4}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper"
      >
      {Img?.length>1?
       Img.map((item,k)=>(
        <SwiperSlide key={k}>
        <img src={item.Url} alt="slider" />
      </SwiperSlide>)
       )
       :<div></div>
       }
      </Swiper>
    
     </div>
     :
     <img src="/assets/images/Item_ComingSoon.jpg" alt="slider" /> 
     }</> 
  );
};

export default ProductSlider;
